import { render, staticRenderFns } from "./BoardPromotions.vue?vue&type=template&id=36773cf8&scoped=true&"
import script from "./BoardPromotions.vue?vue&type=script&lang=js&"
export * from "./BoardPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36773cf8",
  null
  
)

export default component.exports